"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchBanner = exports.BANNER_URL = void 0;
// Mapper
const mapper_1 = require("./mapper");
exports.BANNER_URL = `${window.MIDDLEWARE_BASE_HOST}/mb-api-comm-offers`;
const fetchBanner = ({ API, section, version = 'v2', propositionAreaId = 'lateral-banner', interstitialType = 'commercial', }) => {
    const url = `${exports.BANNER_URL}/${version}/proposition-areas/${propositionAreaId}?section=${section}&interstitialType=${interstitialType}&addVisualizations=true`;
    return API.GET(url).then(response => (0, mapper_1.mapBannerData)(response?.data?.propositions?.[0] ?? {}));
};
exports.fetchBanner = fetchBanner;
const bannerRepository = {
    fetchBanner: exports.fetchBanner,
};
exports.default = bannerRepository;
//# sourceMappingURL=repository.js.map